/**
 * 前後の空白文字と指定した文字の前後の空白を取り除き、指定した文字できれいに区切られた文字列にします。
 *
 * @param {String} text
 * @param {String} separator
 * @returns {string}
 */
export function tidySeparator(text, separator = ',') {
    const safeSeparator = separator.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    const pattern = new RegExp(`[\\s\u3000]*${safeSeparator}[\\s\u3000]*`, 'g');
    return text.trim().replace(pattern, separator);
}
